// extracted by mini-css-extract-plugin
export var ExpertAvatar = "expert-module--ExpertAvatar--f6adc";
export var ExpertBio = "expert-module--ExpertBio--fd92b";
export var ExpertLabel = "expert-module--ExpertLabel--c5684";
export var ExpertLeft = "expert-module--ExpertLeft--7a174";
export var ExpertText = "expert-module--ExpertText--1f0b5";
export var ExpertWrapper = "expert-module--ExpertWrapper--f0d06";